import { Alert, Grid, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { forgotPassword } from '../api/api-middleware';
import Loading from '../components/Loading/loading';
import ForgotPasswordForm from '../components/forgot-password/ForgotPasswordForm';
import AuthWrapper from '../layout/auth/auth-wrapper';

function ForgotPasswordPage() {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [showResponse, setShowResponse] = useState(false);

  const handleSubmit = async (values) => {
    setError(null);
    try {
      const user = {
        email: values.email,
      };
      let response = await forgotPassword(user);
      if (!response.ok) {
        const errorResponse = await response.json();
        if (errorResponse.message === 'RECORDS_NOT_FOUND') {
          setError('This email is not registered.');
        } else {
          throw new Error(errorResponse.message);
        }
      } else {
        const successResponse = await response.json();
        setResponse(successResponse);
        setShowResponse(true);
      }
    } catch (error) {
      setError('This email is not registered.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthWrapper>
      {loading ? (
        <Loading />
      ) : (
        <>
          {showResponse ? (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ mb: { xs: -0.5, sm: 0.5 } }}>
                  <Typography variant="h4" gutterBottom color="success.main">
                    Success!
                  </Typography>
                  <Typography variant="subtitle2">
                    {response.message}
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          ) : (
            <>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ mb: { xs: -0.5, sm: 0.5 } }}>
                    <Typography variant="h4" gutterBottom>
                      Forgot Password
                    </Typography>
                    <Typography variant="subtitle2">
                      Please enter your email address
                    </Typography>
                  </Stack>
                </Grid>

                <Grid item xs={12}>
                  {error ? (
                    <Alert severity="error" sx={{ mb: 2 }}>
                      {error}
                    </Alert>
                  ) : null}
                  <ForgotPasswordForm onSubmit={handleSubmit} />
                </Grid>
              </Grid>
            </>
          )}
        </>
      )}
    </AuthWrapper>
  );
}

export default ForgotPasswordPage;
